<template>
  <ul class="nodelist-container">
    <li
      class="nodelist-wrap"
      v-for="(wrapItem, wrapIndex) in wrapList"
      :key="wrapIndex"
    >
      <p class="nodestat-title">
        <van-icon name="location" :color="wrapItem.color" size="0.6rem" />
        <span>{{ wrapItem.name }}：</span>
      </p>
      <ul class="nodelist">
        <li class="node" v-for="(item, index) in wrapItem.list" :key="index">
          <div class="classtime">{{ item.ClassTime }}</div>
          <div class="nodeinfo">
            <p class="nodename">
              <span>{{ item.NodeName }}</span>
              <span class="c999">({{ item.CityName }})</span>
            </p>
            <p>
              <span class="c999">人数：</span>
              <span
                >{{ item.SaleCount }}人 (含预订:{{
                  item.BookTicketCount
                }}人)</span
              >
            </p>
            <p v-if="wrapItem.code != 'arrival'">
              <span class="c999">已检：</span>
              <span
                >{{ item.CheckedTickets }}人 (含混检:{{
                  item.MixCheckedTickets
                }}人)</span
              >
            </p>
          </div>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    // 日班次GID
    lineClassDayGID: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      wrapList: [
        {
          code: "start",
          name: "上车点统计",
          color: "#ea9518",
          list: [],
        },
        {
          code: "arrival",
          name: "下车点统计",
          color: "#1dfa2c",
          list: [],
        },
      ],
    };
  },
  // 挂载前加载上车点信息
  beforeMount() {
    this.startNodeQuery();
    this.arrivalNodeQuery();
  },
  methods: {
    startNodeQuery() {
      this.$http
        .post(this.$api.getStartNode, {
          LineClassDayGID: this.lineClassDayGID,
        })
        .then((res) => {
          this.wrapList[0].list = res.data;
        });
    },
    arrivalNodeQuery() {
      this.$http
        .post(this.$api.getArrivalNode, {
          LineClassDayGID: this.lineClassDayGID,
        })
        .then((res) => {
          const list = res.data;
          list.forEach((i) => {
            i.ClassTime = this.$moment(i.PredictOutTime).format("HH:mm");
          });
          this.wrapList[1].list = list;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.nodelist-container {
  background: white;
  font-size: 0.41rem;

  .nodelist-wrap {
    .nodestat-title {
      margin-left: 0.128rem;

      span {
        vertical-align: top;
      }
    }

    .node {
      display: flex;
      margin: 0 0.256rem;
      padding: 0.385rem 0 0.256rem;
      border-bottom: 1px solid #ccc;

      &:nth-last-child(1) {
        border: 0;
      }

      .classtime {
        font-weight: bolder;
        color: #0f9fff;
        line-height: 0.59rem;
        padding: 0 0.385rem;
      }

      .nodeinfo {
        p {
          margin-bottom: 0.128rem;

          &:nth-child(1) {
            margin-bottom: 0.256rem;
          }
        }
      }
    }
  }
}
</style>
